module.exports = __webpack_public_path__ + "../resources/img/img_loading.6b1f8529.gif";